import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

function MyProfile() {
  const navigate = useNavigate()
  const [loggedUser, setLoggedUser] = useState()

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo) {
      setLoggedUser(userInfo)
    }
  }, [])

  const logoutHandler = () => {
    localStorage.removeItem('userInfo')
    localStorage.removeItem('authToken')
    navigate('*')
  }

  // phoneNumber handle
  const formatPhoneNumber = phoneNumber => {
    if (!phoneNumber) return ''

    // Handle phone numbers with country code
    if (phoneNumber.startsWith('91') && phoneNumber.length >= 12) {
      return `+${phoneNumber.substring(0, 2)} ${phoneNumber.substring(
        2,
        7
      )} ${phoneNumber.substring(7)}`
    }

    // For other formats or shorter numbers, add basic formatting
    if (phoneNumber.length === 10) {
      return `${phoneNumber.substring(0, 5)}-${phoneNumber.substring(5)}`
    }
    return phoneNumber
  }

  return (
    <>
      <div class="appHeader text-light">
        <div class="left">
          <a
            href=""
            class="headerButton goBack"
            onClick={() => navigate('/dashboard')}
          >
            <ion-icon name="arrow-back-outline"></ion-icon>
          </a>
        </div>
        <div class="pageTitle">Profile</div>
      </div>

      <div id="appCapsule">
        <div class="section mt-2">
          <div class="profile-head my-pro-1">
            <div class="avatar my-pro-2">
              {loggedUser && (
                <img
                  src={loggedUser.pic}
                  alt="avatar"
                  class="imaged w140 rounded"
                />
              )}
              <div
                className="edit-img"
                style={{
                  backgroundColor: '#bdbdbd',
                  border: '1px solid #bdbdbd'
                }}
              >
                <div class="edit-img-icon">
                  <ion-icon name="camera-outline" colo></ion-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul class="listview image-listview mt-3">
          {loggedUser && (
            <>
              <li>
                <div class="item">
                  <div class="icon-box ">
                    <ion-icon name="person-outline"></ion-icon>
                  </div>
                  <div class="in">
                    <div>
                      <footer>Name</footer>
                      {loggedUser.name}
                    </div>
                  </div>
                  <div class="icon-box ">
                    <ion-icon name="pencil-outline"></ion-icon>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <div class="icon-box ">
                    <ion-icon name="alert-circle-outline"></ion-icon>
                  </div>
                  <div class="in">
                    <div>
                      <footer>About</footer>Bhai kam se kam rahk
                    </div>
                  </div>
                  <div class="icon-box ">
                    <ion-icon name="pencil-outline"></ion-icon>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <div class="icon-box ">
                    <ion-icon name="call-outline"></ion-icon>
                  </div>
                  <div class="in">
                    <div>
                      <footer>Mobile No.</footer>
                      {formatPhoneNumber(loggedUser.phone)}
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <div class="icon-box ">
                    <ion-icon name="mail-outline"></ion-icon>
                  </div>
                  <div class="in">
                    <div>
                      <footer>Email</footer>
                      {loggedUser.email}
                    </div>
                  </div>
                </div>
              </li>
            </>
          )}
          <li className="mt-1 log-out">
            <div
              class="item inn"
              onClick={logoutHandler}
              style={{ cursor: 'pointer' }}
            >
              <div class="icon-box ">
                <ion-icon
                  name="log-out-outline"
                  role="img"
                  class="md hydrated"
                  aria-label="thumbs-down-sharp"
                  style={{ color: '#aa3d32' }}
                ></ion-icon>
              </div>
              <div class="in">
                <div className="text-danger">Logout</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  )
}

export default MyProfile
